import styled from 'styled-components/macro';

const Card = styled.div`
  width: 100%;
`;

export default Card;
